<template>
  <div class="main">

    <div class="flex">
      <!---------------------------------------- 画布页面 ---------------------------------------->
      <div @click="setTemplateDiv" style="width: 100%; height: 100%">
        <el-card class="editPage">
          <div class="mianPage">
            <carousel :editForm="editForm" class="draggableDiv" v-if="templateDiv.objectType == '轮播图'"></carousel>
            <div class="draggableDiv" :style="templateDiv.style" v-else>
              <draggable class="syllable_ul" element="div" :list="dynamicList" :options="{ group: 'title', animation: 150 }" :no-transition-on-drag="true" @start="start" @end="end">
                <div v-for="(item, index) in dynamicList" :key="item.id">
                  <zuHe-template v-if="templateDiv.objectType == '组合'" :item="item" :index="index" :noClick="false" v-on:choosesubmuban="chooseSubMuban" v-on:chooseMuban="chooseMuban"></zuHe-template>
                  <template-one v-else :item="item" :index="index" v-on:choosesubmuban="chooseSubMuban" v-on:chooseMuban="chooseMuban"></template-one>
                </div>
              </draggable>
            </div>
          </div>
        </el-card>
      </div>

    </div>
  </div>
</template>
<script>
import templateOne from "../../onlineTemplate/template/index";
import draggable from "vuedraggable";
import editPanel from "../../onlineTemplate/template/editPanel";
import carousel from "../../onlineTemplate/template/carousel";
import editCarousel from "../../onlineTemplate/template/editCarousel";
import zuHeTemplate from "../../onlineTemplate/template/zuHeTemplate";
import mixin from "../../onlineTemplate/mixin";
export default {
  mixins: [mixin],
  components: {
    draggable,
    templateOne,
    editPanel,
    editCarousel,
    carousel,
    zuHeTemplate,
  },
  props: {
  },
  methods: {
    //获取模板属性
    //商品  广告  轮播图
    getGoodsOptions (val) {
      console.log(val);
      let parentId = "1415194153601642498";
      this.api.dictionary.getDictionaryListByParentId({
        parentId,
      }).then((res) => {
        this.goodsOptions = res.data;
        if (val) {
          res.data.forEach((item) => {
            if (val == item.id) {
              this.getParamOptions(item.id, item.name);
            }
          });
        } else {
          res.data.forEach((item) => {
            if (item.name == this.templateDiv.objectType) {
              this.getParamOptions(item.id, item.name);
            }
          });
        }
      });
    },
    //获取绑定字段数组
    //例如：
    //商品需要绑定的字段 image logo price
    getParamOptions (parentId, name) {
      console.log(parentId);
      if (this.templateDiv.objectType == "组合") {
        this.templateDiv.objectId = parentId;
        return;
      }
      //轮播图不需要绑定字段
      if (name == "轮播图") {
        this.templateDiv.objectId = parentId;
        this.editForm.objectId = parentId;
        this.initCarouselData();
      } else {
        this.api.dictionary
          .getDictionaryListByParentId({
            parentId,
          })
          .then((res) => {
            this.paramOptions = res.data;
            if (!this.templateId) {
              this.templateDiv.objectId = parentId;
              this.editForm.objectId = parentId;
              this.setData();
            }
          });
      }
    },
    //初始化轮播图数据dynamicList  templateDiv  editForm
    initCarouselData () {
      if (!this.templateId) {
        this.templateDiv.height = 300;
        this.editForm.height = 300;
        this.templateDiv.style = this.getStyle(this.templateDiv);
        this.editForm.style = this.getStyle(this.editForm);
      }

      this.templateDiv = {
        direction: "horizontal",
        autoplay: true,
        indicatorPosition: "inside",
        ...this.templateDiv,
      };
      this.editForm = {
        direction: "horizontal",
        autoplay: true,
        indicatorPosition: "inside",
        ...this.editForm,
      };
    },
    //初始化数据dynamicList  templateDiv  editForm
    initData () {
      this.templateDiv = {
        name: 0,
        width: 600,
        height: undefined,
        event: undefined,
        frameId: undefined,
        active: undefined,
        borderRadius: 0,
        padding: 10,
        label: "main",
        custom: undefined,
        objectId: undefined,
        objectType: this.$route.query.type,
        background: undefined,
        marginTop: 0,
        css: undefined,
        templateId: undefined,
        style: "height:auto;width:602px;padding:10px; box-sizing: border-box;",
      };
      this.editForm = {
        label: "main",
        height: "",
        width: 600,
        title: undefined,
        padding: 10,
        event: undefined,
        frameId: undefined,
        active: undefined,
        marginTop: 0,
        css: undefined,
        background: undefined,
        objectType: this.$route.query.type,
        custom: undefined,
        marginLeft: 0,
        fontSize: 13,
        color: "#303133",
        fontWeight: undefined,
        textAlign: "left",
        url: undefined,
        methods: undefined,
        borderRadius: 0,
        objectId: undefined,
        rate: 3,
        className: "",
        attribute: undefined,
      };
      this.initDynamicList();
      this.getGoodsOptions();
    },
    initDynamicList () {
      if (this.$route.query.type == "广告") {
        this.dynamicList = [
          {
            id: 0,
            isChoose: false,
            padding: 0,
            src: undefined,
            title: undefined,
            attribute: undefined,
            style: "height:300px;width:580px",
            label: "image",
            height: 300,
            width: 580,
            custom: undefined,
            marginTop: 0,
            css: undefined,
            marginLeft: 0,
            background: undefined,
            fontSize: 13,
            color: "#303133",
            fontWeight: undefined,
            textAlign: "left",
            methods: undefined,
            url: undefined,
            borderRadius: 0,
            event: undefined,
            frameId: undefined,
            active: undefined,
          },
        ];
      } else {
        this.dynamicList = [];
      }
    },
    //遍历dynamicList，设置它的初始title跟attribute
    setData () {
      let obj = this.paramOptions[0];
      this.dynamicList.forEach((item) => {
        if (item.htmlStyleList) {
          item.htmlStyleList.forEach((_item) => {
            _item.attribute = obj.remark;
            _item.title = obj.name;
          });
        }
        item.attribute = obj.remark;
        item.title = obj.name;
      });
    },
    //获取模板详情
    getDetail () {
      this.api.template.getTemplate(this.templateId).then((res) => {
        this.getGoodsOptions(res.data.objectId);
        this.getDynamicList(res.data.htmlStyleList);
        this.getTemplateDiv(res.data);
      });
    },
    //给templateDiv  editForm赋值
    getTemplateDiv (obj) {
      obj.htmlStyleList = undefined;
      obj = this.objectAssign(obj);
      this.templateDiv = obj;
      this.editForm = JSON.parse(JSON.stringify(obj));
    },
    //给dynamicList
    getDynamicList (arr) {
      let newArr = [];
      arr.forEach((item) => {
        let itemArr = [];
        if (item.htmlStyleList.length != 0) {
          item.htmlStyleList.forEach((_item) => {
            _item = this.objectAssign(_item);
            itemArr.push(_item);
          });
        }
        item = this.objectAssign(item);
        item.htmlStyleList = itemArr;
        newArr.push(item);
      });
      this.dynamicList = newArr;
    },
    //对象合并
    objectAssign (obj) {
      let jsonObj = JSON.parse(obj.styleJson);
      return Object.assign({}, jsonObj, obj);
    },

    //保存按钮
    saveBtn (bol) {

      if (this.templateId && !bol) {
        this.$confirm("是否保存此次修改?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.saveForm(this.templateDiv.name, bol);
        })
          .catch(() => { });
      } else {
        this.$prompt("请输入模板名称", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        })
          .then(({ value }) => {
            this.saveForm(value, bol);
          })
          .catch(() => { });
      }
    },
    //保存
    saveForm (name, bol) {
      let sort = 1;
      let arr = [];
      if (this.templateDiv.objectType != "轮播图") {
        this.dynamicList.forEach((item) => {
          let jsonString = "";
          let childrenArr = undefined;
          if (item.htmlStyleList) {
            item.htmlStyleList.forEach((_item) => {
              _item.styleJson = undefined;
              _item.template = undefined;

              jsonString = JSON.stringify(_item);
              _item.sort = sort;
              _item.styleJson = jsonString;
              sort++;
            });
            childrenArr = JSON.parse(JSON.stringify(item.htmlStyleList));
          }
          item.styleJson = undefined;
          item.template = undefined;

          item.htmlStyleList = undefined;
          jsonString = JSON.stringify(item);
          item.sort = sort;
          sort++;
          item.styleJson = jsonString;
          item.htmlStyleList = childrenArr;
          arr.push(item);
        });
      } else {
        this.dynamicList = [];
      }
      console.log(this.templateDiv);
      this.templateDiv.style = this.getStyle(this.templateDiv, true);
      console.log(this.templateDiv.style);
      console.log(3333333333);

      this.templateDiv.styleJson = undefined;
      let templateObj = {
        ...this.templateDiv,
        name,
        styleJson: JSON.stringify(this.templateDiv),
        htmlStyleList: this.dynamicList,
      };
      if (bol) {
        this.templateId = undefined;
      }
      if (this.templateId) {
        templateObj.id = this.templateId;
        this.api.template.updateTemplate(templateObj).then((res) => {
          this.$message({
            message: res.message,
            type: "success",
          });
          this.goBack();
        });
      } else {
        console.log(templateObj);
        console.log(9999999);
        this.api.template.addTemplate(templateObj).then((res) => {
          this.$message({
            message: res.message,
            type: "success",
          });
          this.goBack();
        });
      }
    },
    initEveryTIme (tempId, tempType) {
      this.$route.query.id = tempId
      this.$route.query.type = tempType
      console.log('child', this.tempId, this.tempType)
      if (this.$route.query.id) {
        this.templateId = this.$route.query.id;
        this.getDetail();
      } else {
        this.initData();
      }
    },
  },
  mounted () {
    this.initEveryTIme()
  },
};
</script>
<style scoped>
.main {
  height: calc(100% - 50px) !important;
  width: 100%;
}
.pageHeader {
  background: #ffffff;
  margin-bottom: 20px;
  padding: 24px;
}
.flex {
  display: flex;
  height: calc(100% - 72px);
  padding: 0 20px;
  box-sizing: border-box;
  justify-content: space-between;
}
.editPage {
  cursor: pointer;
  flex: 1;
  height: 100%;
  margin-right: 20px;
  background: rgba(53, 58, 54, 0.7);
  align-items: center;
  box-sizing: border-box;
  overflow-y: scroll;
}
.editPage >>> .el-card__body {
  padding: 0;
  height: 100%;
  width: 100%;
  align-items: center;
  flex-direction: column;
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
}
.mianPage {
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
}
.draggableDiv {
  border: 1px solid #000;
  background: #ffffff;
}
.itemDiv {
  width: 100%;
}
.syllable_ul {
  width: 100%;

  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/components/onlineSchool/components/previewTemp.vue